export class FormFieldsMasks {

  public postCode() {
    return [/\d/, /\d/, '-', /\d/, /\d/, /\d/];
  }

  public date() {
    return [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/];
  }

  public phone() {
    return ['+','4','8',' ', /\d/,/\d/,/\d/, ' ', /\d/,/\d/,/\d/, ' ', /\d/,/\d/,/\d/];
  }

  public nip() {
    return [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  }

  public idNumber() {
    return [/[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  }

  public mIdNumber() {
    return [/[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /\d/, /\d/, /\d/, /\d/, /\d/];
  }

  public pesel() {
    return [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  }

  public regon() {
    return [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  }
}
